import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import {
  ColumnMode,
  SelectionType,
  DatatableComponent,
} from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss'],
        encapsulation: ViewEncapsulation.None
})
export class PaymentsComponent implements OnInit {


  // @ViewChild('editDateModal') editDateModal: any;

selectedInstallment: any;
// editPaymentDateValue: string | null = null;
editDateModalRef: any;


@ViewChild('editDateModal') editDateModal!: TemplateRef<any>;

selectedPayment: any = null;
editPaymentDateValue: string = '';

  public ads: any[] = [];
     public pages  : any
  payData: any;
 
  paidAmount: number | null = null;
selectedRow: any;
paidAmountModalRef: any;
// paidAmount: number | null = null;
transferImage: File | null = null;

@ViewChild('paidAmountModal') paidAmountModal: any;


   constructor( 
     private apisService: ApisService,
     // private loadingService: Loadingscr,
     private router: Router,
             private toastr : ToastrService,
               private modalService: NgbModal,
                 public _translateService: TranslateService
   ) {} 
 
   public currentPage = 1; 
   public itemsPerPage = 10;
   public totalItems = 0;
   public messages: any = {};
  paymentsData: any[] = [];
  ColumnMode = ColumnMode;
 
   public tempData = [];
 
   @ViewChild(DatatableComponent) table: DatatableComponent;
 
   public SelectionType = SelectionType;v
 
   ngOnInit(): void {
                  this.getPaymentData();
 
   
      this.setDatatableMessages(); // set initial messages
 
     // listen for language change dynamically
     this._translateService.onLangChange.subscribe(() => {
       this.setDatatableMessages();
     });
 
   }
 
    private setDatatableMessages() {
     this.messages = {
       totalMessage: this._translateService.instant('MENU.DASHBOARD.total')
     };
   }
 
 // getTags() {
 //   this.apisService.contracts().subscribe({
 //     next: (response: any) => {
 //       this.pages = response.data || [];
 //       this.totalItems = this.pages.length;
 //       console.log("pages:", this.pages);
 //     },
 //     error: (error: any) => {
 //       console.error(error);
 //     },
 //   });
 // }
  getPaymentData() {
    this.apisService.paidPayments().subscribe({
      next: (response: any) => {
        // إذا كان الرد يحتوي على مصفوفة
        if (Array.isArray(response.data)) {
          this.paymentsData = response.data;
        } 
        // إذا كان الرد يحتوي على كائن واحد
        else if (response.data) {
          this.paymentsData = [response.data];
        } 
        else {
          this.paymentsData = [];
        }
        
        this.totalItems = this.paymentsData.length;
        console.log("paymentsData:", this.paymentsData);
      },
      error: (error: any) => {
        console.error('Error fetching paymentsData:', error);
        this.paymentsData = [];
      }
    });
  }

  onTransferImageSelected(event: any) {
  const file = event.target.files[0];
  if (file) {
    this.transferImage = file;
  }
}

isPdf(file: string): boolean {
  return file?.toLowerCase().includes('.pdf');
}


submitPaidAmount() {
  if (!this.paidAmount || !this.transferImage) {
    return;
  }

  const formData = new FormData();
  formData.append('paid_amount', this.paidAmount.toString());
  formData.append('transfer_image', this.transferImage);

  this.apisService
    .addPaidAmount(this.selectedRow.id, formData)
    .subscribe({
      next: () => {
        this.toastr.success(
          this._translateService.instant('MENU.DASHBOARD.PAID_SUCCESS')
        );

        this.paidAmountModalRef.close();
        this.getPaymentData();
      },
      error: (err) => {
        console.error(err);
        this.toastr.error(
          this._translateService.instant('MENU.DASHBOARD.SOMETHING_WENT_WRONG')
        );
      }
    });
}

addPayment(id: any): void {
  if (!id) return;
  this.router.navigate(['/add-payments-amount', id]);
}


openPaidAmountModal(row: any) {
  this.selectedRow = row;
  this.paidAmount = null;

  this.paidAmountModalRef = this.modalService.open(this.paidAmountModal, {
    centered: true,
    backdrop: 'static'
  });
}


  viewPaymentDetails(paymentId: number) {
    // كود عرض تفاصيل الدفعة
    console.log('View payment details:', paymentId);
  }

  downloadReceipt(paymentId: number) {
    // كود تحميل الإيصال
    console.log('Download receipt for payment:', paymentId);
  }

  // confirmDelete(paymentId: number) {
  //   // كود تأكيد الحذف
  //   console.log('Delete payment:', paymentId);
  // }
 
   addCoupon() {
     this.router.navigate(["main/coupons/add-coupon"]);
   }
 
   
 
  
 
   filterUpdate(event) {
     const val = event.target.value.toLowerCase();
     this.ads = this.tempData.filter((d) =>
       d.code.toLowerCase().includes(val)
     );
     this.table.offset = 0;
   }
 
 
      /*----------  deleting   ----------*/
  DeleteContracts(id:any){ 
   this.apisService.DeleteContracts(id).subscribe({
     next: (response: any) => {
    this.toastr.success(
         this._translateService.instant('MENU.DASHBOARD.DELETED_SUCCESSFULLY')
       );       this.getPaymentData();
     },
     error: (error: any) => {
       console.log(error);
    this.toastr.error(
         this._translateService.instant('MENU.DASHBOARD.SOMETHING_WENT_WRONG')
       );    }
   }
     
   )
  } 
 
  editProduct(productId: number) {
   this.router.navigate(['/edit-contracts', productId]);
 }
 
 confirmDelete(id: any) {
   Swal.fire({
     title: this._translateService.instant('MENU.DASHBOARD.CONFIRM_DELETE_TITLE'),
     text: this._translateService.instant('MENU.DASHBOARD.CONFIRM_DELETE_TEXT'),
     icon: 'warning',
     showCancelButton: true,
     confirmButtonText: this._translateService.instant('MENU.DASHBOARD.YES_DELETE'),
     cancelButtonText: this._translateService.instant('MENU.DASHBOARD.CANCEL')
   }).then((result) => {
     if (result.isConfirmed) {
       this.DeleteContracts(id);
     }
   });
 }
 


openEditDateModal(row: any): void {
  if (!row?.payment_date || !row?.id) {
    this.toastr.error(
      this._translateService.instant('MENU.DASHBOARD.NO_PAYMENT_DATE')
    );
    return;
  }

  // نخزن الدفعة الحالية
  this.selectedPayment = row;

  // نحط التاريخ الحالي في input
  this.editPaymentDateValue = row.payment_date;

  this.modalService.open(this.editDateModal, {
    centered: true,
    backdrop: 'static'
  });
}


submitEditDate(): void {
  if (!this.selectedPayment || !this.editPaymentDateValue) return;

  const payload = {
    payment_date: this.editPaymentDateValue
  };

  this.apisService
    .addPaidInstallments(this.selectedPayment.id, payload)
    .subscribe({
      next: () => {
        this.toastr.success(
          this._translateService.instant('MENU.DASHBOARD.DATE_UPDATED_SUCCESS')
        );

        this.modalService.dismissAll();
        this.getPaymentData(); // إعادة تحميل الجدول
      },
 error: (err) => {
  console.error(err);

  this.toastr.error(
    err?.error?.message ||
    this._translateService.instant('MENU.DASHBOARD.SOMETHING_WENT_WRONG')
  );
}

    });
}



}
